import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/vue-headful'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-pro/css/all.css'
import VueLuxon from "vue-luxon";
import VueYouTubeEmbed from 'vue-youtube-embed'

Vue.config.productionTip = false

Vue.use(VueLuxon)
Vue.use(VueYouTubeEmbed)

console.log('%cPassie voor onderwijs%c POrtaal\r\n' +
    '%cVersion: %c' + process.env.VUE_APP_VERSION + '\r\n' +
    '%cAPI: %c' + process.env.https://api.portaal.passie-voor-onderwijs.nl + '\r\n' +
    //'%cLanguage: %c' + i18n.locale + ' %c(' + navigator.languages + ') \r\n'+
    '%cDeveloped by: %cInternetbureau Forwart%c - %chttps://www.forwart.nl/',
    'color: #61bec9; font-weight: bold; font-size: 1.3em;',
    'color: #4f4f4f; font-size: 1.3em;',
    'color: #888', 'color: #999;',
    'color: #888', 'color: #999;',
    //'color: #888', 'color: #28358D;', 'color: #ccc',
    'color: #888', 'color: #ec2e24; font-weight: bold', 'color: #333', 'color: #00f; text-decoration: underline;'
);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
